import Box from "@mui/material/Box";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import { ThemeProvider } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { InnerContentBox } from "src/components/ContentBox/ContentBox";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import InputBase from "@mui/material/InputBase";
import { useGetUserQuery } from "src/redux/service/users.service";
import CircularProgress from "@mui/material/CircularProgress";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { User } from "src/model_types/user.types";
import theme, { backgroundColor } from "src/styles/mainstyle";
import { Snackbar, useMediaQuery, useTheme } from "@mui/material";
import { UserInfo } from "./OwnUserPage";
import { Home } from "src/model_types/home.types";

export default function UserPage() {
  const { id } = useParams();
  const mobileTheme = useTheme();
  const isDesktop = useMediaQuery(mobileTheme.breakpoints.down("sm"));
  const { data: user, isLoading: isUserLoading, refetch } = useGetUserQuery(id);

  const [showEnglishHint, setShowEnglishHint] = useState(false);

  if (isUserLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  return (
    <Box>
      <ThemeProvider theme={theme}>
        <Header />
        <Box
          sx={{
            p: 5,
          }}
        />
        <Grid
          container
          spacing={3}
          justifyContent="space-between"
          alignItems="stretch"
          sx={{ p: 6 }}
        >
          <Grid
            item
            xs={12}
            sm={6}
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <UserInfo
              user={user || ({} as User)}
              setUpdateData={() => {
                return;
              }}
              updateData={user || ({} as User)}
              isDesktop={isDesktop}
              isPublicProfile={true}
              refetch={refetch}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <InnerContentBox
              title={""}
              sx={{
                flexGrow: 1,
                maxWidth: !isDesktop ? "33.33vw" : "90vw",
                pt: 0,
                // ml: "2%",
              }}
            >
              <Grid container spacing={0}>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <TextBoxWithTitle
                    nRows={8}
                    title={"Description about " + user?.firstName}
                    value={user?.questions?.shortDescription}
                    disabled={true}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <TextBoxWithTitle
                    nRows={2}
                    title={"Favorite dish"}
                    value={user?.questions?.favouriteDish}
                    disabled={true}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <TextBoxWithTitle
                    nRows={4}
                    title={"Describe a perfect weekend"}
                    value={user?.questions?.perfectWeekend}
                    disabled={true}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <TextBoxWithTitle
                    nRows={3}
                    title={"Favourite music genre"}
                    value={user?.questions?.favouriteGenre}
                    disabled={true}
                  />
                </Grid>
              </Grid>
            </InnerContentBox>
          </Grid>
        </Grid>
      </ThemeProvider>
      <Footer />
      <Snackbar
        open={showEnglishHint}
        autoHideDuration={3000}
        onClose={() => setShowEnglishHint(false)}
        message="Please write your profile in English."
        ContentProps={{
          sx: {
            background: backgroundColor, // your dark blue
            color: "#fff", // text color
          },
        }}
      />
    </Box>
  );
}

type TextBoxWithTitleProps = {
  nRows: number;
  disabled?: boolean;
  onChange?: (e: any) => void;
  title: string;
  value?: string;
};

export const TextBoxWithTitle = ({
  nRows,
  disabled,
  onChange,
  title,
  value,
}: TextBoxWithTitleProps) => {
  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          marginTop: 2,
          width: "100%",
        }}
      >
        <Typography variant="body1" component="p">
          {title}
        </Typography>
        <InputLabel>
          <InputBase
            onChange={onChange}
            multiline
            rows={nRows}
            disabled={disabled}
            value={value}
            fullWidth
            sx={{
              backgroundColor: theme.palette.primary.main,
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              "& .MuiInputBase-input": {
                fontSize: theme.typography.h6.fontSize,
              },
            }}
          />
        </InputLabel>
      </Box>
    </ThemeProvider>
  );
};
